export const contactsQueryKey = 'contacts';

export const crmSettings = {
  canWriteData: true,
  canDeleteData: true,
  rootPartnerId: '00000000-0000-0000-0000-aaaabbbb1111'
};
